import {UserPermission, UserRoles} from 'types';
import {ProfileRole} from 'types/profile';

export const ROLES_MATRIX: Partial<Record<UserRoles, UserPermission[]>> = {
    [UserRoles.ROLE_MPL_OPERATOR_ADMIN]: [
        UserPermission.DOCUMENT_GRID_VIEW,
        UserPermission.DOCUMENT_DETAIL_VIEW,
        UserPermission.PROFILE_DATA_VIEW,
        UserPermission.PROFILE_DATA_EDITING,
        UserPermission.GTIN_CREATE,
        UserPermission.INTERNAL_CARD_CREATE,
        UserPermission.FACTORY_GRID_VIEW,
        UserPermission.FACTORY_CARD_VIEW,
        // UserPermission.FACTORY_CONTROL_CREATE,
        // UserPermission.FACTORY_LINE_CONTROL_CREATE,
        // UserPermission.RECEIPT_CREATE,
        UserPermission.RECEIPT_GRID_VIEW,
        UserPermission.RECEIPT_CARD_VIEW,
        UserPermission.FACTORY_CONTROL_EDIT,
        UserPermission.FACTORY_LINE_CONTROL_EDIT,
        UserPermission.VIRTUAL_WAREHOUSE_VIEW,
        UserPermission.ALL_PRODUCT_GRID_VIEW,
        UserPermission.DOCUMENT_VIEW_UTILISATION,
        UserPermission.DOCUMENT_VIEW_AGGREGATION,
        UserPermission.DOCUMENT_VIEW_DROPOUT,
        UserPermission.DOCUMENT_VIEW_COMMISSIONING,
        UserPermission.ALL_GTIN_GRID_VIEW,
        UserPermission.GTIN_DETAIL_VIEW,
        UserPermission.PRODUCT_DETAIL_VIEW,
        UserPermission.CUSTOMS_LIST,
        UserPermission.CUSTOMS_EDIT,
        UserPermission.CUSTOMS_CREATE,
        // UserPermission.CUSTOMS_EMPLOYEE_LIST,
        UserPermission.CUSTOMS_EMPLOYEE_DETAILS,
        // UserPermission.CUSTOMS_EMPLOYEE_CREATE,
        UserPermission.CUSTOMS_EMPLOYEE_EDIT,
        UserPermission.CUSTOMS_DECLARATION_LIST,
        UserPermission.CUSTOMS_DECLARATION_DETAILS,
        UserPermission.DOCUMENTS_DECLARATION_LIST,
        UserPermission.DOCUMENTS_DECLARATION_DETAILS,
        UserPermission.INVOICE_TRANSFER_VIEW,
        UserPermission.FACTORY_BILLING_VIEW,
    ],
    [UserRoles.ROLE_MPL_OPERATOR]: [
        UserPermission.DOCUMENT_GRID_VIEW,
        UserPermission.DOCUMENT_DETAIL_VIEW,
        // UserPermission.GTIN_CREATE,
        UserPermission.FACTORY_GRID_VIEW,
        UserPermission.FACTORY_CARD_VIEW,
        UserPermission.VIRTUAL_WAREHOUSE_VIEW,
        UserPermission.ALL_PRODUCT_GRID_VIEW,
        UserPermission.DOCUMENT_VIEW_UTILISATION,
        UserPermission.DOCUMENT_VIEW_AGGREGATION,
        UserPermission.DOCUMENT_VIEW_DROPOUT,
        UserPermission.DOCUMENT_VIEW_COMMISSIONING,
        UserPermission.ALL_GTIN_GRID_VIEW,
        UserPermission.GTIN_DETAIL_VIEW,
        UserPermission.PRODUCT_DETAIL_VIEW,
        UserPermission.INVOICE_TRANSFER_VIEW,
        UserPermission.FACTORY_BILLING_VIEW,
    ],
    [UserRoles.ROLE_MPL_MANUFACTURER_DIRECTOR]: [
        UserPermission.PRODUCT_GRID_VIEW,
        UserPermission.PRODUCT_CARD_VIEW,
        UserPermission.DOCUMENT_GRID_VIEW,
        UserPermission.DOCUMENT_DETAIL_VIEW,
        UserPermission.PROFILE_DATA_VIEW,
        UserPermission.PROFILE_DATA_EDITING,
        UserPermission.GTIN_GRID_VIEW,
        UserPermission.GTIN_DETAIL_VIEW,
        UserPermission.GTIN_CREATE,
        UserPermission.INTERNAL_CARD_CREATE,
        UserPermission.FACTORY_GRID_VIEW,
        UserPermission.FACTORY_CARD_VIEW,
        UserPermission.FACTORY_CONTROL_CREATE,
        UserPermission.FACTORY_LINE_CONTROL_CREATE,
        UserPermission.FACTORY_CONTROL_EDIT,
        UserPermission.FACTORY_LINE_CONTROL_EDIT,
        UserPermission.VIRTUAL_WAREHOUSE_VIEW,
        UserPermission.DOCUMENT_CREATE_UTILISATION,
        UserPermission.DOCUMENT_VIEW_UTILISATION,
        UserPermission.DOCUMENT_CREATE_AGGREGATION,
        UserPermission.DOCUMENT_VIEW_AGGREGATION,
        UserPermission.DOCUMENT_CREATE_DROPOUT,
        UserPermission.DOCUMENT_VIEW_DROPOUT,
        UserPermission.DOCUMENT_CREATE_COMMISSIONING,
        UserPermission.DOCUMENT_VIEW_COMMISSIONING,
        UserPermission.INVOICE_TRANSFER_VIEW,
        UserPermission.FACTORY_BILLING_VIEW,
        UserPermission.ROLE_TYPE_EDIT,
    ],
    [UserRoles.ROLE_MPL_MANUFACTURER_EMPLOYEE]: [
        UserPermission.PRODUCT_GRID_VIEW,
        UserPermission.PRODUCT_CARD_VIEW,
        UserPermission.DOCUMENT_GRID_VIEW,
        UserPermission.DOCUMENT_DETAIL_VIEW,
        UserPermission.PROFILE_DATA_VIEW,
        UserPermission.GTIN_GRID_VIEW,
        UserPermission.GTIN_DETAIL_VIEW,
        // UserPermission.GTIN_CREATE,
        UserPermission.FACTORY_GRID_VIEW,
        UserPermission.FACTORY_CARD_VIEW,
        UserPermission.FACTORY_CONTROL_CREATE,
        UserPermission.FACTORY_LINE_CONTROL_CREATE,
        UserPermission.FACTORY_CONTROL_EDIT,
        UserPermission.FACTORY_LINE_CONTROL_EDIT,
        UserPermission.VIRTUAL_WAREHOUSE_VIEW,
        UserPermission.DOCUMENT_CREATE_UTILISATION,
        UserPermission.DOCUMENT_VIEW_UTILISATION,
        UserPermission.DOCUMENT_CREATE_AGGREGATION,
        UserPermission.DOCUMENT_VIEW_AGGREGATION,
        UserPermission.DOCUMENT_VIEW_DROPOUT,
        UserPermission.DOCUMENT_CREATE_COMMISSIONING,
        UserPermission.DOCUMENT_VIEW_COMMISSIONING,
        UserPermission.INVOICE_TRANSFER_VIEW,
        UserPermission.FACTORY_BILLING_VIEW,
        UserPermission.ROLE_TYPE_VIEW,
    ],
    [UserRoles.ROLE_MPL_IMPORTER_DIRECTOR]: [
        UserPermission.PRODUCT_GRID_VIEW,
        UserPermission.PRODUCT_CARD_VIEW,
        UserPermission.DOCUMENT_GRID_VIEW,
        UserPermission.DOCUMENT_DETAIL_VIEW,
        UserPermission.PROFILE_DATA_VIEW,
        UserPermission.PROFILE_DATA_EDITING,
        UserPermission.GTIN_GRID_VIEW,
        UserPermission.GTIN_DETAIL_VIEW,
        UserPermission.GTIN_CREATE,
        UserPermission.FACTORY_GRID_VIEW,
        UserPermission.FACTORY_CARD_VIEW,
        UserPermission.FACTORY_CONTROL_CREATE,
        UserPermission.FACTORY_LINE_CONTROL_CREATE,
        UserPermission.FACTORY_CONTROL_EDIT,
        UserPermission.FACTORY_LINE_CONTROL_EDIT,
        UserPermission.VIRTUAL_WAREHOUSE_VIEW,
        UserPermission.DOCUMENT_CREATE_UTILISATION,
        UserPermission.DOCUMENT_VIEW_UTILISATION,
        UserPermission.DOCUMENT_CREATE_AGGREGATION,
        UserPermission.DOCUMENT_VIEW_AGGREGATION,
        UserPermission.DOCUMENT_CREATE_DROPOUT,
        UserPermission.DOCUMENT_VIEW_DROPOUT,
        UserPermission.DOCUMENT_VIEW_COMMISSIONING,
        UserPermission.DOCUMENTS_DECLARATION_LIST,
        UserPermission.DOCUMENTS_DECLARATION_DETAILS,
        UserPermission.DOCUMENTS_DECLARATION_CREATE,
        UserPermission.DOCUMENTS_DECLARATION_EDIT,
        UserPermission.DOCUMENTS_DECLARATION_CHANGE_TO_SUBMIT_STATUS,
        UserPermission.INVOICE_TRANSFER_VIEW,
        UserPermission.FACTORY_BILLING_VIEW,
        UserPermission.ROLE_TYPE_EDIT,
    ],
    [UserRoles.ROLE_MPL_IMPORTER_EMPLOYEE]: [
        UserPermission.PRODUCT_GRID_VIEW,
        UserPermission.PRODUCT_CARD_VIEW,
        UserPermission.DOCUMENT_GRID_VIEW,
        UserPermission.DOCUMENT_DETAIL_VIEW,
        UserPermission.PROFILE_DATA_VIEW,
        UserPermission.GTIN_GRID_VIEW,
        UserPermission.GTIN_DETAIL_VIEW,
        // UserPermission.GTIN_CREATE,
        UserPermission.FACTORY_GRID_VIEW,
        UserPermission.FACTORY_CARD_VIEW,
        UserPermission.FACTORY_CONTROL_CREATE,
        UserPermission.FACTORY_LINE_CONTROL_CREATE,
        UserPermission.FACTORY_CONTROL_EDIT,
        UserPermission.FACTORY_LINE_CONTROL_EDIT,
        UserPermission.VIRTUAL_WAREHOUSE_VIEW,
        UserPermission.DOCUMENT_CREATE_UTILISATION,
        UserPermission.DOCUMENT_VIEW_UTILISATION,
        UserPermission.DOCUMENT_CREATE_AGGREGATION,
        UserPermission.DOCUMENT_VIEW_AGGREGATION,
        UserPermission.DOCUMENT_VIEW_DROPOUT,
        UserPermission.DOCUMENT_VIEW_COMMISSIONING,
        UserPermission.DOCUMENTS_DECLARATION_LIST,
        UserPermission.DOCUMENTS_DECLARATION_DETAILS,
        UserPermission.DOCUMENTS_DECLARATION_CREATE,
        UserPermission.DOCUMENTS_DECLARATION_EDIT,
        UserPermission.DOCUMENTS_DECLARATION_CHANGE_TO_SUBMIT_STATUS,
        UserPermission.INVOICE_TRANSFER_VIEW,
        UserPermission.FACTORY_BILLING_VIEW,
        UserPermission.ROLE_TYPE_VIEW,
    ],
    [UserRoles.ROLE_MPL_DISTRIBUTOR_DIRECTOR]: [
        UserPermission.PRODUCT_GRID_VIEW,
        UserPermission.PRODUCT_CARD_VIEW,
        UserPermission.DOCUMENT_GRID_VIEW,
        UserPermission.DOCUMENT_DETAIL_VIEW,
        UserPermission.PROFILE_DATA_VIEW,
        UserPermission.PROFILE_DATA_EDITING,
        UserPermission.GTIN_GRID_VIEW,
        UserPermission.VIRTUAL_WAREHOUSE_VIEW,
        UserPermission.DOCUMENT_CREATE_AGGREGATION,
        UserPermission.DOCUMENT_VIEW_AGGREGATION,
        UserPermission.DOCUMENT_CREATE_DROPOUT,
        UserPermission.DOCUMENT_VIEW_DROPOUT,
        UserPermission.INVOICE_TRANSFER_VIEW,
        UserPermission.FACTORY_BILLING_VIEW,
        UserPermission.ROLE_TYPE_EDIT,
    ],
    [UserRoles.ROLE_MPL_DISTRIBUTOR_EMPLOYEE]: [
        UserPermission.PRODUCT_GRID_VIEW,
        UserPermission.PRODUCT_CARD_VIEW,
        UserPermission.DOCUMENT_GRID_VIEW,
        UserPermission.DOCUMENT_DETAIL_VIEW,
        UserPermission.PROFILE_DATA_VIEW,
        UserPermission.GTIN_GRID_VIEW,
        UserPermission.VIRTUAL_WAREHOUSE_VIEW,
        UserPermission.DOCUMENT_CREATE_AGGREGATION,
        UserPermission.DOCUMENT_VIEW_AGGREGATION,
        UserPermission.DOCUMENT_VIEW_DROPOUT,
        UserPermission.INVOICE_TRANSFER_VIEW,
        UserPermission.FACTORY_BILLING_VIEW,
        UserPermission.ROLE_TYPE_VIEW,
    ],
    [UserRoles.ROLE_MPL_RETAIL_DIRECTOR]: [
        UserPermission.PRODUCT_GRID_VIEW,
        UserPermission.PRODUCT_CARD_VIEW,
        UserPermission.DOCUMENT_GRID_VIEW,
        UserPermission.DOCUMENT_DETAIL_VIEW,
        UserPermission.PROFILE_DATA_VIEW,
        UserPermission.PROFILE_DATA_EDITING,
        UserPermission.GTIN_GRID_VIEW,
        UserPermission.RECEIPT_CREATE,
        UserPermission.RECEIPT_GRID_VIEW,
        UserPermission.RECEIPT_CARD_VIEW,
        UserPermission.VIRTUAL_WAREHOUSE_VIEW,
        UserPermission.DOCUMENT_CREATE_DROPOUT,
        UserPermission.DOCUMENT_VIEW_DROPOUT,
        UserPermission.INVOICE_TRANSFER_VIEW,
        UserPermission.ROLE_TYPE_EDIT,
    ],
    [UserRoles.ROLE_MPL_RETAIL_EMPLOYEE]: [
        UserPermission.PRODUCT_GRID_VIEW,
        UserPermission.PRODUCT_CARD_VIEW,
        UserPermission.DOCUMENT_GRID_VIEW,
        UserPermission.DOCUMENT_DETAIL_VIEW,
        UserPermission.PROFILE_DATA_VIEW,
        UserPermission.GTIN_GRID_VIEW,
        UserPermission.RECEIPT_CREATE,
        UserPermission.RECEIPT_GRID_VIEW,
        UserPermission.RECEIPT_CARD_VIEW,
        UserPermission.VIRTUAL_WAREHOUSE_VIEW,
        UserPermission.DOCUMENT_VIEW_DROPOUT,
        UserPermission.INVOICE_TRANSFER_VIEW,
        UserPermission.ROLE_TYPE_VIEW,
    ],
    [UserRoles.ROLE_MPL_TS_DIRECTOR]: [
        UserPermission.DOCUMENT_DETAIL_VIEW,
        UserPermission.PROFILE_DATA_VIEW,
        UserPermission.PRODUCT_CARD_VIEW,
        UserPermission.RECEIPT_CARD_VIEW,

        UserPermission.CUSTOMS_DECLARATION_CONFIRM,
        UserPermission.CUSTOMS_DECLARATION_DOWNLOAD,
        UserPermission.CUSTOMS_LIST,
        UserPermission.CUSTOMS_EDIT,
        UserPermission.CUSTOMS_CREATE,
        UserPermission.CUSTOMS_EMPLOYEE_LIST,
        UserPermission.CUSTOMS_EMPLOYEE_DETAILS,
        UserPermission.CUSTOMS_EMPLOYEE_CREATE,
        UserPermission.CUSTOMS_EMPLOYEE_EDIT,
        UserPermission.CUSTOMS_DECLARATION_LIST,
        UserPermission.CUSTOMS_DECLARATION_DETAILS,
        UserPermission.CUSTOMS_DECLARATION_CHANGE_TO_REVIEW_STATUS,
        UserPermission.CUSTOMS_DECLARATION_CONFIRM_OR_REJECT,
    ],
    [UserRoles.ROLE_MPL_TS_EMPLOYEE]: [
        UserPermission.PROFILE_DATA_VIEW,
        UserPermission.PRODUCT_CARD_VIEW,

        UserPermission.CUSTOMS_LIST,
        UserPermission.CUSTOMS_EMPLOYEE_LIST,
        UserPermission.CUSTOMS_DECLARATION_LIST,
        UserPermission.CUSTOMS_DECLARATION_DETAILS,
        UserPermission.CUSTOMS_DECLARATION_CHANGE_TO_REVIEW_STATUS,
        UserPermission.CUSTOMS_DECLARATION_CONFIRM_OR_REJECT,
    ],
};

export const ROLES_MAP: Partial<Record<UserRoles, ProfileRole>> = {
    [UserRoles.ROLE_MPL_MANUFACTURER_DIRECTOR]: ProfileRole.MANUFACTURER,
    [UserRoles.ROLE_MPL_MANUFACTURER_EMPLOYEE]: ProfileRole.MANUFACTURER,
    [UserRoles.ROLE_MPL_IMPORTER_DIRECTOR]: ProfileRole.IMPORTER,
    [UserRoles.ROLE_MPL_IMPORTER_EMPLOYEE]: ProfileRole.IMPORTER,
    [UserRoles.ROLE_MPL_DISTRIBUTOR_DIRECTOR]: ProfileRole.DISTRIBUTOR,
    [UserRoles.ROLE_MPL_DISTRIBUTOR_EMPLOYEE]: ProfileRole.DISTRIBUTOR,
    [UserRoles.ROLE_MPL_RETAIL_DIRECTOR]: ProfileRole.RETAILER,
    [UserRoles.ROLE_MPL_RETAIL_EMPLOYEE]: ProfileRole.RETAILER,
};
